/**
 * The single "Booked By" box on the Track Booking card: name, then email
 * and phone underneath, in place of three separate boxes. A missing email
 * (it's optional at booking) drops its line rather than printing "N/A".
 *
 * @param {object} props
 * @param {object} props.booking - the booking being shown
 * @returns {JSX.Element}
 */
function BookingStatusContactBox({ booking }) {
  return (
    <div className="info-item">
      <label>Booked By</label>
      <p className="bss-contact-name">{booking.userName || 'N/A'}</p>
      {booking.email && (
        <p><span className="bss-contact-label">Email:</span> {booking.email}</p>
      )}
      <p><span className="bss-contact-label">Phone:</span> {booking.phone || 'N/A'}</p>
    </div>
  );
}

export default BookingStatusContactBox;
